import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getTeamDetails, leaveTeam } from '../api/team_stuff';

const ViewTeamProfile = () => {
    const { teamname } = useParams();
    const [team, setTeam] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTeam = async () => {
            try {
                const data = await getTeamDetails(teamname);
                setTeam(data);
            } catch (err) {
                setError('Failed to load team details.');
            } finally {
                setLoading(false);
            }
        };

        fetchTeam();
    }, [teamname]);

    if (loading) return <p className="text-center mt-8 text-gray-600">Loading team profile...</p>;
    if (error) return <p className="text-center mt-8 text-red-500">{error}</p>;

    const coach = team.members.find(member => member.role === "Coach");

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="container mx-auto p-4">
                <div className="bg-white shadow-lg rounded-xl p-6 mb-6 text-center">
                    <h1 className="text-4xl font-bold text-blue-600 mb-2">{team.name}</h1>
                    <p className="text-gray-500 italic">{team.org}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-white shadow-md rounded-lg p-4">
                        <h2 className="text-2xl font-semibold text-gray-700 mb-3">Team Coach</h2>
                        {coach ? (
                            <Link
                                to={`/profile/${coach.name}`}
                                className="block bg-blue-100 text-blue-800 font-medium p-3 rounded hover:bg-blue-200 transition"
                            >
                                {coach.name}
                            </Link>
                        ) : (
                            <p className="text-gray-500">No coach assigned.</p>
                        )}
                    </div>

                    <div className="bg-white shadow-md rounded-lg p-4">
                        <h2 className="text-2xl font-semibold text-gray-700 mb-3">Team Members</h2>
                        <ul className="space-y-3">
                            {team.members
                                .filter(member => member.role !== "Coach")
                                .map((member, index) => (
                                    <li key={index}>
                                        <Link
                                            to={`/profile/${member.name}`}
                                            className="block border border-gray-300 p-3 rounded hover:bg-gray-100 transition"
                                        >
                                            <span className="font-medium text-gray-800">{member.name}</span>
                                        </Link>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </div>
                {(!team.liuitm)||(
                    <div className="bg-white shadow-md rounded-lg p-4 gap-4 mt-4">
                        <h2 className="text-2xl font-semibold text-gray-700 mb-3">Team Settings Options</h2>                        
                        <div className="space grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Link to={`/edit_team/${encodeURIComponent(team.name)}`}
                            className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-blue-500 text-white py-3 px-4 text-center">
                                Edit Team
                            </Link>  
                            <button
                                onClick={async () => {
                                    await leaveTeam();
                                    navigate(`/view_teams`);
                                }}
                                className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-red-500 text-white py-3 px-4 text-center"
                            >
                                Leave Team
                            </button> 
                            
                            {/*
                            <Link to={`/leave_team/${encodeURIComponent(team.name)}`}
                            className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-red-500 text-white py-2 px-4 rounded text-center">
                                Leave Team
                            </Link>  
                            */}
                        </div>
                    </div>
                )}
            </div>
            <CustomFooter />
        </div>
    );
};

export default ViewTeamProfile;
